import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import ReactCodeInput, { ReactCodeInputProps } from 'react-code-input'
import { mutualTheme } from '~/utils/theme'

const useStyles = makeStyles({
  input: {
    '& input': {
      width: '46px',
      height: '50px',
      fontSize: '14px',
      textAlign: 'center',
      borderRadius: '5px',
      border: '1px solid #DFDFDF',
      MozAppearance: 'textfield',
      backgroundColor: 'transparent',
      fontFamily: 'Lato,sans-serif',
      margin: mutualTheme.spacing(0.5)
    }
  }
})

export type CodeInputProps = ReactCodeInputProps

export const CodeInput: React.FC<CodeInputProps> = (props) => {
  const { className, inputMode, disabled, ...rest } = props
  const classes = useStyles()

  return (
    <ReactCodeInput
      inputMode={inputMode}
      disabled={disabled}
      className={clsx([classes.input, className])}
      {...rest}
    />
  )
}
